var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-skeleton',{attrs:{"loading":_vm.loading,"paragraph":{ rows: 6 }}},[_c('div',[_vm._v(" Chỉ cho xóa thôi ^^ "),_c('div',{style:({
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      })},[_c('a-popconfirm',{attrs:{"title":"Xác nhận xóa thông tin?","ok-text":"Có","cancel-text":"Không"},on:{"confirm":_vm.onDeletedItem}},[_c('a-button',{staticStyle:{"float":"left"},attrs:{"icon":"delete","type":"danger","loading":_vm.loadingBtn}},[_vm._v(" Xóa ")])],1),_c('a-button',{staticStyle:{"margin-right":"10px"},on:{"click":_vm.close}},[_vm._v(" Đóng ")]),_c('a-button',{attrs:{"type":"primary","loading":_vm.loadingBtn},on:{"click":_vm.onSubmit}},[_vm._v(" Cập nhật ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }